import React from 'react'
import PropTypes from 'prop-types'
import './VehicleDetails.scss'

const VehicleDetails = ({ id, className, children }) => (
  <div className={`VehicleDetails ${className}`} id={id}>
    <div className="VehicleDetails__container">{children}</div>
  </div>
)

VehicleDetails.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
}

export default VehicleDetails
